var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.092,
    height: 18.001,
    viewBox: "0 0 16.092 18.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4261",
    "data-name": "Path 4261",
    d: "M1.136,37.83a6.824,6.824,0,0,0,2.907,5.593.563.563,0,0,1,.029.9l-.008.007a.562.562,0,0,1-.669.021A7.959,7.959,0,0,1,0,37.83a8.049,8.049,0,0,1,7.992-7.968V31A6.912,6.912,0,0,0,1.136,37.83Zm0,0",
    transform: "translate(0 -28.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4262",
    "data-name": "Path 4262",
    d: "M224.961.034l2.088,1.428a.193.193,0,0,1,0,.318l-2.088,1.428a.193.193,0,0,1-.3-.159V.193a.193.193,0,0,1,.3-.159Zm0,0",
    transform: "translate(-216.761 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4263",
    "data-name": "Path 4263",
    d: "M237.412,73.679a6.825,6.825,0,0,0-2.907-5.593.563.563,0,0,1-.029-.9l.008-.007a.562.562,0,0,1,.669-.021,7.959,7.959,0,0,1,3.394,6.526,8.043,8.043,0,0,1-7.985,7.968V80.51a6.907,6.907,0,0,0,6.85-6.832Zm0,0",
    transform: "translate(-222.456 -64.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4264",
    "data-name": "Path 4264",
    d: "M164.873,423.007l-2.088-1.428a.193.193,0,0,1,0-.318l2.088-1.428a.193.193,0,0,1,.3.159v2.856A.193.193,0,0,1,164.873,423.007Zm0,0",
    transform: "translate(-156.981 -405.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4265",
    "data-name": "Path 4265",
    d: "M126.14,186.783l-3.419,2.836-.862.715a1.128,1.128,0,0,1-1.623-.192l-1.33-1.773a.907.907,0,0,1,1.451-1.088l.9,1.2.007-.006,3.721-3.086a.907.907,0,1,1,1.157,1.4Zm0,0",
    transform: "translate(-114.55 -178.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4266",
    "data-name": "Path 4266",
    d: "M195.761,186.784l-3.419,2.836a4.593,4.593,0,0,1-1.459-1.146l3.721-3.086a.907.907,0,1,1,1.157,1.4Zm0,0",
    transform: "translate(-184.172 -178.668)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/update-icon.026c3950515ac1d3440848c32306f3c7.svg";
export { ForwardRef as ReactComponent };